import React from 'react';
import { useNavigate } from 'react-router-dom';
import SyllabusDownloadButton from '../SyllabusDownloadButton/SyllabusDownloadButton';
import styles from './MasterDegreeView.module.css';

function MasterDegreeView({ masterDegree }) {
  const navigate = useNavigate();

  return (
    <>
      {/* Banner */}
      <div className={styles.banner}>
        {masterDegree.bannerImageS3 ? (
          <img src={masterDegree.bannerImageS3} alt={masterDegree.name} className={styles.bannerImg} />
        ) : (
          <div className={styles.bannerPlaceholder} />
        )}
        <div className={styles.bannerOverlay}>
          <div className={styles.bannerLeft}>
            <h1 className={styles.bannerTitle}>{masterDegree.name}</h1>
            {masterDegree.generalInfo && (
              <div className={styles.heroGrid}>
                {masterDegree.generalInfo.duration && (
                  <div className={styles.heroItem}>
                    <span className={styles.heroLabel}>Duración</span>
                    <span className={styles.heroValue}>{masterDegree.generalInfo.duration}</span>
                  </div>
                )}
                {masterDegree.generalInfo.schedule && (
                  <div className={styles.heroItem}>
                    <span className={styles.heroLabel}>Horarios</span>
                    <span className={styles.heroValue}>{masterDegree.generalInfo.schedule}</span>
                  </div>
                )}
                {masterDegree.generalInfo.subjects && (
                  <div className={styles.heroItem}>
                    <span className={styles.heroLabel}>Materias</span>
                    <span className={styles.heroValue}>{masterDegree.generalInfo.subjects}</span>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className={styles.bannerRight}>
            <button
              type="button"
              className={styles.bannerCta}
              onClick={() => navigate(`/inscripcion?careerId=${masterDegree._id}`)}
            >
              Inscríbete ahora
            </button>
          </div>
        </div>
      </div>

      {/* Two-column content */}
      <div className={styles.content}>

        {/* ── Left column ── */}
        <div className={styles.leftCol}>
          {masterDegree.tagline && <p className={styles.tagline}>{masterDegree.tagline}</p>}
          {masterDegree.description && <p className={styles.description}>{masterDegree.description}</p>}

          {/* ¿Qué vas a aprender? — triangle bubble layout */}
          {masterDegree.whatYouWillLearn?.length > 0 && (
            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>¿Qué vas a aprender?</h2>
              <div className={styles.bubbleGrid}>
                {masterDegree.whatYouWillLearn.map((block, i) => (
                  <div key={i} className={styles.bubbleCircle}>
                    <span className={styles.bubbleAreaName}>{block.area}</span>
                    <span className={styles.bubbleDivider} aria-hidden="true" />
                    <ul className={styles.bubbleSubjectList}>
                      {block.subjects.map((s, j) => (
                        <li key={j}>{s}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* Perfil del egresado */}
          {masterDegree.graduateProfile?.length > 0 && (
            <section className={styles.profileCapsule}>
              <div className={styles.profileLeft}>
                <h2 className={styles.sectionTitle}>Perfil del egresado</h2>
                <ul className={styles.bulletList}>
                  {masterDegree.graduateProfile.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
              <img src="/egresado.png" alt="" className={styles.degreeImg01} aria-hidden="true" />
            </section>
          )}

          <div className={styles.imgCenterBlock}>
            <button
              type="button"
              className={styles.img02Btn}
              onClick={() => navigate(`/inscripcion?careerId=${masterDegree._id}`)}
              aria-label="Comenzar inscripción"
            >
              <img src="/degree/02.png" alt="" className={styles.degreeImg02} />
            </button>
          </div>
        </div>

        {/* ── Right column ── */}
        <div className={styles.rightCol}>
          {/* Info card */}
          {masterDegree.generalInfo && (
            <div className={styles.infoCard}>
              <div className={styles.infoRow}>
                <span className={styles.infoIcon}>📅</span>
                <div>
                  <p className={styles.infoLabel}>Duración</p>
                  <p className={styles.infoValue}>{masterDegree.generalInfo.duration}</p>
                </div>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.infoIcon}>🕐</span>
                <div>
                  <p className={styles.infoLabel}>Horarios</p>
                  <p className={styles.infoValue}>{masterDegree.generalInfo.schedule}</p>
                </div>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.infoIcon}>📚</span>
                <div>
                  <p className={styles.infoLabel}>Materias</p>
                  <p className={styles.infoValue}>{masterDegree.generalInfo.subjects}</p>
                </div>
              </div>
              {masterDegree.generalInfo.graduation?.length > 0 && (
                <div className={styles.infoRow}>
                  <span className={styles.infoIcon}>🎓</span>
                  <div>
                    <p className={styles.infoLabel}>Titulación</p>
                    <ol className={styles.graduationList}>
                      {masterDegree.generalInfo.graduation.map((g, i) => (
                        <li key={i}>{g}</li>
                      ))}
                    </ol>
                  </div>
                </div>
              )}
              <button
                type="button"
                className={styles.ctaBtn}
                onClick={() => navigate(`/inscripcion?careerId=${masterDegree._id}`)}
              >
                Comenzar tu inscripción ahora
              </button>
            </div>
          )}

          <SyllabusDownloadButton url={masterDegree.syllabusUrl} fullWidth />

        </div>
      </div>
    </>
  );
}

export default MasterDegreeView;
